class RequestError extends Error {
  constructor(response, text, ...params) {
    super(...params);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, RequestError);
    }

    const {status, statusText} = response;

    try {
      this.json = JSON.parse(text);
    } catch (e) {
      this.json = {errors: [{message: 'Oops! Something went wrong'}]};
    }

    this.status = status;
    this.statusText = statusText;
    this.message = `${status} - ${statusText}\n\n${text}`;
  }
}

/**
 * Raise an error if the provided Response object is not in
 * the "ok" range (200-299). Otherwise, it returns the object.
 * @param  {Obj} response Response object
 * @return {Obj}
 */
export function raiseForStatus(response) {
  if (response.ok) {
    return response;
    // if (response.status === 204) return response;

    // return response.text().then((text) => {
    //   try {
    //     return JSON.parse(text);
    //   } catch (e) {
    //     throw new Error(`Body could not be parsed as JSON: ${text}`);
    //   }
    // });
  }
  return response.text().then((text) => {
    throw new RequestError(response, text);
  });
}
